import React from 'react';

const WalletGuideModal = ({ isOpen, onClose, onProceed }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
        <button className="modal-close" onClick={onClose}>&times;</button>

        <h2 style={{ textAlign: 'center', marginBottom: '5px' }}>
          Vincular Billetera Crypto
        </h2>
        <p style={{ textAlign: 'center', color: '#666', fontSize: '0.9rem', marginBottom: '20px' }}>
          Antes de continuar, te explicamos brevemente cómo funciona.
        </p>

        <div style={{ background: '#f8f9ff', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
          <h3 style={{ color: '#1a1a2e', marginBottom: '12px', fontSize: '1.05rem' }}>
            ¿Qué es una billetera crypto (wallet)?
          </h3>
          <p style={{ margin: '0 0 10px', lineHeight: '1.6', fontSize: '0.92rem' }}>
            Es una aplicación que te permite <strong>almacenar, enviar y recibir criptomonedas</strong> de forma segura. 
            Funciona como tu cuenta bancaria digital, pero <strong>tú tienes el control total</strong> de tus fondos.
          </p>
        </div>

        <div style={{ background: '#f0fff4', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
          <h3 style={{ color: '#1a1a2e', marginBottom: '12px', fontSize: '1.05rem' }}>
            ¿Por qué necesito vincular una?
          </h3>
          <p style={{ margin: '0 0 10px', lineHeight: '1.6', fontSize: '0.92rem' }}>
            Para operar con XCOIN necesitas una billetera en la red <strong>BNB Smart Chain</strong>. 
            Al vincularla a tu cuenta, podrás:
          </p>
          <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '0.92rem', lineHeight: '1.8' }}>
            <li>Comprar y vender tokens XCOIN</li>
            <li>Recibir dividendos mensuales</li>
            <li>Ver tu balance en tiempo real</li>
          </ul>
        </div>

        <div style={{ background: '#fff8f0', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
          <h3 style={{ color: '#1a1a2e', marginBottom: '12px', fontSize: '1.05rem' }}>
            ¿Qué billeteras puedo usar?
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '0.92rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg" alt="MetaMask" style={{ width: '28px', height: '28px' }} />
              <div>
                <strong>MetaMask</strong>
                <div style={{ color: '#666', fontSize: '0.82rem' }}>La mas popular en PC</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img src="https://trustwallet.com/assets/images/favicon.png" alt="Trust Wallet" style={{ width: '28px', height: '28px' }} />
              <div>
                <strong>Trust Wallet</strong>
                <div style={{ color: '#666', fontSize: '0.82rem' }}>Ideal en celulares</div>
              </div>
            </div>
          </div>
          <p style={{ margin: '12px 0 0', color: '#666', fontSize: '0.85rem', lineHeight: '1.5' }}>
            Si no tienes una billetera, te recomendamos instalar{' '}
            <a href="https://metamask.io/download/" target="_blank" rel="noopener noreferrer" style={{ color: '#0e0c9e' }}>
              MetaMask
            </a>{' '}
            (extensión de navegador) o{' '}
            <a href="https://trustwallet.com/download" target="_blank" rel="noopener noreferrer" style={{ color: '#0e0c9e' }}>
              Trust Wallet
            </a>{' '}
            (app móvil).
          </p>
        </div>

        <div style={{ background: '#f0f4ff', borderRadius: '8px', padding: '15px', marginBottom: '25px', borderLeft: '4px solid #0e0c9e' }}>
          <p style={{ margin: '0', fontSize: '0.88rem', lineHeight: '1.5', color: '#444' }}>
            <strong>Importante:</strong> XCOIN nunca te pedirá tu frase semilla (seed phrase) ni tus claves privadas. 
            La conexión es segura y solo permite <strong>leer tu dirección</strong> y <strong>firmar transacciones</strong> que tú apruebes.
          </p>
        </div>

        <div className="modal-actions" style={{ justifyContent: 'center', gap: '15px' }}>
          <button
            className="btn"
            onClick={onClose}
            style={{ 
              background: '#f0f0f0', 
              color: '#555', 
              padding: '12px 25px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              cursor: 'pointer',
              fontSize: '0.95rem'
            }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={onProceed}
            style={{ 
              padding: '12px 30px',
              borderRadius: '8px',
              fontSize: '0.95rem',
              fontWeight: 'bold'
            }}
          >
            Conectar mi Billetera →
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletGuideModal;
